import { Button, Box, Flex, Text, Grid, Input, TextArea } from "../primitives" 

function Subtitle({styleClass, children}){
    return(
        <Box className={`text-xl font-semibold ${styleClass}`}>{children}</Box>
    )
}

export default Subtitle